import { createContext, useContext } from "react";

const ProjectDetailsContext = createContext(null);

export const useProjectDetailsContext = () => useContext(ProjectDetailsContext);

export default ProjectDetailsContext;
